import type { ReactNode } from 'react';
import * as RTabs from '@radix-ui/react-tabs';
import './Tabs.css';

export interface TabItem {
  value: string;
  label: ReactNode;
  content: ReactNode;
  disabled?: boolean;
}

export interface TabsProps {
  items: TabItem[];
  /** Controlled active tab. */
  value?: string;
  /** Initial active tab (uncontrolled); defaults to the first item. */
  defaultValue?: string;
  onValueChange?: (value: string) => void;
}

// State tabs (underline style) — replaces the per-page .as-tabs / .sv-tab*.
export function Tabs({ items, value, defaultValue, onValueChange }: TabsProps): JSX.Element {
  return (
    <RTabs.Root
      className="dsr-tabs"
      value={value}
      defaultValue={defaultValue ?? items[0]?.value}
      onValueChange={onValueChange}
    >
      <RTabs.List className="dsr-tabs-list">
        {items.map((t) => (
          <RTabs.Trigger key={t.value} value={t.value} disabled={t.disabled} className="dsr-tab">
            {t.label}
          </RTabs.Trigger>
        ))}
      </RTabs.List>
      {items.map((t) => (
        <RTabs.Content key={t.value} value={t.value} className="dsr-tab-panel">
          {t.content}
        </RTabs.Content>
      ))}
    </RTabs.Root>
  );
}
